import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-user-badge',
  imports: [],
  templateUrl: './user-badge.component.html',
  styleUrl: './user-badge.component.scss'
})
export class UserBadgeComponent {
  readonly name = input.required<string, string>({ transform: (value) => value.toUpperCase() });
  readonly styleClass = input<string>('size-[80px]');
  readonly selectedColor = computed(() => this.avatarColors[this.name().charCodeAt(0) % this.avatarColors.length]);

  readonly avatarColors = [
    'bg-red-500', 'bg-amber-500', 'bg-teal-500', 'bg-sky-500', 'bg-blue-500',
    'bg-indigo-500', 'bg-purple-500', 'bg-pink-500', 'bg-zinc-500', 'bg-lime-500'
  ]
}
